import {Platform} from 'react-native';
import FastImage from 'react-native-fast-image';
import {getBottomSpace} from 'react-native-iphone-screen-helper';
import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';

export const Container = styled.View`
  flex: 1;
  background-color: ${({theme}) => theme.colors.background};
`;

export const Content = styled.View`
  padding: 0 24px;
  flex: 1;
`;

export const HeaderCard = styled.View`

  border-radius: ${RFValue(16)}px;
  border: 1px solid ${({theme}) => theme.colors.border2};
  padding: 0 ${RFValue(12)}px;
  background-color: ${({theme}) => theme.colors.background};
  shadow-color: #000;
  shadow-opacity: 0.06;
  shadow-radius: 8px;
  shadow-offset: 0px 4px;
  elevation: 3;
  
`;

export const ItemList = styled.View`
  border-radius: ${RFValue(16)}px;
  border: 1px solid ${({theme}) => theme.colors.border2};
  padding: ${RFValue(4)}px ${RFValue(12)}px ${RFValue(8)}px;
  background-color: ${({theme}) => theme.colors.background};
  shadow-color: #000;
  shadow-opacity: 0.06;
  shadow-radius: 8px;
  shadow-offset: 0px 4px;
  elevation: 3;
  
  margin-top: ${RFValue(12)}px;
`;

export const Item = styled.View`
  flex-direction: row;
  align-items: center;
  padding: ${RFValue(10)}px 0;
  border-bottom-width: 1px;
  border-bottom-color: ${({theme}) => theme.colors.border2};
`;

export const ItemContainer = styled.View`
  margin-left: ${RFValue(12)}px;
  flex: 1;
`;

export const ItemName = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(14)}px;
`;

export const Label = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(12)}px;
`;

export const ContentHeader = styled.View`
  flex-direction: row;
  align-items: center;
  margin: ${RFValue(12)}px 0;
`;
export const LogoImage = styled(FastImage)`
  height: ${RFValue(68)}px;
  width: ${RFValue(68)}px;
  border: 3px solid ${({theme}) => theme.colors.image_border};
  border-radius: ${RFValue(16)}px;
`;

export const UnitInfos = styled.View`
  margin-left: ${RFValue(12)}px;
`;
export const State = styled.Text`
  color: ${({theme}) => theme.colors.primary};
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.regular};
`;
export const Name = styled.Text`
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(14)}px;
  text-transform: capitalize;
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const Footer = styled.View`
  padding: 0 24px;
  margin-top: ${RFValue(6)}px;
  padding-bottom: ${Platform.OS === 'ios' && getBottomSpace()
    ? 0
    : RFValue(20)}px;
`;
